import { useState, useEffect } from "react";
import { Youtube, Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { useSettingsSection } from "@/lib/useSettingsSection";
import { PageTitle, Card, Field, inputCls, SaveButton } from "@/components/admin/ui";

const FIELDS = [
  { key: "youtube", label: "YouTube", Icon: Youtube },
  { key: "facebook", label: "Facebook", Icon: Facebook },
  { key: "instagram", label: "Instagram", Icon: Instagram },
  { key: "linkedin", label: "LinkedIn", Icon: Linkedin },
  { key: "twitter", label: "X / Twitter", Icon: Twitter },
];

export default function AdminSocial() {
  const { settings, saving, save } = useSettingsSection();
  const [s, setS] = useState({});
  useEffect(() => { if (settings) setS(settings.social || {}); }, [settings]);
  if (!settings) return <div className="text-slate-400">Loading…</div>;

  return (
    <div data-testid="admin-social">
      <PageTitle title="Social Links" subtitle="Only configured accounts show an icon on the website. Leave blank to hide." />
      <Card>
        {FIELDS.map(({ key, label, Icon }) => (
          <Field key={key} label={label}>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-sm bg-navy/5 text-navy flex items-center justify-center shrink-0"><Icon size={17} /></span>
              <input className={inputCls} placeholder={`https://…`} value={s[key] || ""} onChange={(e) => setS({ ...s, [key]: e.target.value })} data-testid={`social-${key}-input`} />
            </div>
          </Field>
        ))}
        <SaveButton onClick={() => save({ social: s })} saving={saving} testid="save-social" />
      </Card>
    </div>
  );
}
